import { render, staticRenderFns } from "./products_bar.vue?vue&type=template&id=5d693294&scoped=true&"
import script from "./products_bar.vue?vue&type=script&lang=js&"
export * from "./products_bar.vue?vue&type=script&lang=js&"
import style0 from "./products_bar.vue?vue&type=style&index=0&id=5d693294&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d693294",
  null
  
)

export default component.exports